import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoginComponent} from "./login.component";
import {SharedModule} from "../../shared.module";
import {NzFormModule} from "ng-zorro-antd/form";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzInputModule} from "ng-zorro-antd/input";
import {NzRadioModule} from "ng-zorro-antd/radio";
import {NzAlertModule} from "ng-zorro-antd/alert";
import {NzAvatarModule} from "ng-zorro-antd/avatar";
import {NzLayoutModule} from "ng-zorro-antd/layout";
import {NzSpinModule} from "ng-zorro-antd/spin";
import {NzTabsModule} from "ng-zorro-antd/tabs";


@NgModule({
  declarations: [
    LoginComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        NzFormModule,
        NzButtonModule,
        NzInputModule,
        NzRadioModule,
        NzAlertModule,
        NzAvatarModule,
        NzLayoutModule,
        NzSpinModule,
        NzTabsModule
    ],
  exports: [
    LoginComponent
  ]
})
export class LoginModule { }
